import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-mark.css';
import { UitkMarkSize } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkMark = function (props) {
  var _a, _b;
  var className = props.className,
    url = props.url,
    description = props.description,
    id = props.id,
    name = props.name,
    size = props.size,
    title = props.title,
    shadow = props.shadow,
    orientation = props.orientation,
    lazyLoading = props.lazyLoading;
  var assetsBaseUrl = 'https://a.travel-assets.com/egds/marks/';
  var svgName = "".concat(name, ".svg");
  var baseCssClass = 'uitk-mark';
  if (!name && !url) {
    console.error("Uitk-Mark must have \"name\" or \"url\" prop");
  }
  if (title || shadow) {
    console.error("The following props have been deprecated from Uitk-Mark: \"title\", \"shadow\"");
  }
  var cssClassNames = getClassNameList(baseCssClass, className, (_a = {}, _a["".concat(baseCssClass, "-").concat(orientation, "-oriented")] = orientation, _a));
  var markCustomProps = (_b = {}, _b["--uitk-mark-token-size"] = "var(--mark-size-".concat(size, ")"), _b);
  var buildUrl = function () {
    if (url) {
      return url;
    }
    return "".concat(assetsBaseUrl).concat(svgName);
  };
  var alt = description || '';
  return React.createElement("img", {
    className: cssClassNames,
    alt: alt,
    src: buildUrl(),
    style: markCustomProps,
    id: id,
    loading: lazyLoading === 'off' ? undefined : lazyLoading
  });
};
UitkMark.defaultProps = {
  orientation: 'landscape',
  size: UitkMarkSize.MEDIUM
};
UitkMark.displayName = 'UitkMark';
export { UitkMark };